module.exports = __webpack_public_path__ + "static/Future-of-Work-Template-Articles-1280-x-720-9-800x450-9badbb0ca5b9fe3f730492aa431479ea.png";